const DEFAULT_RETURN_PATH = "/";

/**
 * Builds the login href with the `returnTo` the user should land back on after auth.
 * The `/auth/login` route is blocked from crawlers by `Disallow: /auth/` in robots.txt,
 * so `returnTo` in this URL is never exposed to search engines.
 */
export function buildAuthLoginHref(sanitizedPath: string): string {
  return `/auth/login?returnTo=${encodeURIComponent(sanitizedPath)}`;
}

/**
 * Validates and sanitizes a path intended to be used as an internal redirect destination.
 * Rejects absolute URLs, protocol-relative URLs, and other potential open-redirect vectors.
 */
export function sanitizeReturnTo(input: string | null | undefined): string {
  if (typeof input !== "string") {
    return DEFAULT_RETURN_PATH;
  }

  const trimmed = input.trim();
  if (trimmed.length === 0) {
    return DEFAULT_RETURN_PATH;
  }

  if (!trimmed.startsWith("/")) {
    return DEFAULT_RETURN_PATH;
  }

  if (trimmed.startsWith("//")) {
    return DEFAULT_RETURN_PATH;
  }

  if (trimmed.includes("://")) {
    return DEFAULT_RETURN_PATH;
  }

  if (trimmed.includes("\0")) {
    return DEFAULT_RETURN_PATH;
  }

  return trimmed;
}





